import OnLinkedIn from './on-linkedin';

export default OnLinkedIn;
